<template>
    <div class="text-center">
<!--        <h1>404 Not Found</h1>-->
        <figure>
            <img src="@/assets/error/error_404.jpg" class="mx-auto"/>
            <figcaption class="text-sm-left">Source from: https://dribbble.com/antacle</figcaption>
        </figure>
    </div>
</template>

<script>
    // import "@/assets/error/error_404.jpg"

    export default {
        name: "NotFound.vue"
    }
</script>

<style scoped>

</style>
